import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiBarChart2 } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { getNodeAccent } from '../config/nodeVisualConfig';

const VolumeChartNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('volume_node', data);
  return (
    <NodeWrapper
        selected={selected}
        title="Volume Chart Node"
        type="VISUALIZATION"
        accent={accent}
        icon={FiBarChart2}
        isHighlighted={data.isHighlighted}
    >
        {/* Input: Data Source */}
        <Handle
            type="target"
            id="input_0"
            position={Position.Left}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />

        <div className="space-y-3">
             <div className="bg-bg-3 p-4 rounded-lg border border-[var(--divider)] flex items-center justify-between">
                 <div className="flex items-center gap-3">
                     <div
                        className="w-12 h-8 rounded shadow-sm flex items-end justify-center gap-0.5"
                        style={{ overflow: 'hidden' }}
                     >
                        <div style={{ width: '30%', height: '60%', backgroundColor: data.upColor || 'rgba(0, 194, 146, 0.5)' }}></div>
                        <div style={{ width: '30%', height: '90%', backgroundColor: data.downColor || 'rgba(228, 106, 118, 0.5)' }}></div>
                        <div style={{ width: '30%', height: '40%', backgroundColor: data.upColor || 'rgba(0, 194, 146, 0.5)' }}></div>
                     </div>
                 </div>
                 <div className="flex flex-col items-end">
                    <span className="text-[10px] font-bold text-fg-3 uppercase tracking-wider">Type</span>
                    <span className="text-xs font-mono font-bold text-fg-1">
                        Volume
                    </span>
                 </div>
            </div>
        </div>

        {/* Output: Configuration Data — accent-tinted */}
        <Handle
            type="source"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default VolumeChartNode;
